// ComplaintForwardTo Configuration - UNIFIED APPROACH
import { createTrackingConfig } from '../../../components/generic/labels';
import { tableConfig, uiConfig } from '../../../config/appConfig';

export const complaintForwardToConfig = {
  entityName: 'ComplaintForwardTo',
  api: { 
    baseEndpoint: '/complaint-forward-to', 
    endpoints: { 
      list: '', 
      create: '', 
      update: (id) => `/${id}`, 
      delete: (id) => `/${id}`, 
      getById: (id) => `/${id}` 
    }, 
    lookupEndpoints: {} 
  },
  ui: { 
    drawerWidth: '600px', 
    defaultPageSize: tableConfig.defaultPageSize, 
    pageSizeOptions: tableConfig.pageSizeOptions, 
    defaultTableDensity: tableConfig.defaultDensity, 
    requiredFieldStyle: uiConfig.requiredFieldStyle 
  },
  service: { 
    name: 'complaintForwardToService', 
    methods: { 
      getAll: 'getAllComplaintForwardTos', 
      getById: 'getComplaintForwardToById', 
      create: 'createComplaintForwardTo', 
      update: 'updateComplaintForwardTo', 
      delete: 'deleteComplaintForwardTo', 
      validate: 'validateData' 
    } 
  },
  fields: [
    { 
      name: 'id', 
      label: 'ID', 
      type: 'hidden', 
      table: false, 
      filterable: false 
    },
    { 
      name: 'name', 
      label: 'Forward To Name', 
      type: 'text', 
      required: true, 
      placeholder: 'Enter forward to option (ΠΡ. ΕΜΠΟΡΙΚΟΥ ΤΜΗΜΑΤΟΣ, ΥΠ. ΑΠΟΘΗΚΗΣ, ΠΕΛΑΤΗΣ, Ν/Α)', 
      table: { 
        header: 'Forward To', 
        width: '250px', 
        sortable: true 
      }, 
      filterable: true, 
      validation: { 
        required: true, 
        minLength: 2, 
        maxLength: 100 
      } 
    },
    { 
      name: 'description', 
      label: 'Description', 
      type: 'textarea', 
      required: false, 
      placeholder: 'Describe this forward to option', 
      table: { 
        header: 'Description', 
        width: '250px', 
        sortable: false 
      }, 
      filterable: true, 
      validation: { 
        required: false, 
        maxLength: 500 
      }, 
      rows: 3 
    },
    { 
      name: 'isActive', 
      label: 'Active', 
      type: 'switch', 
      required: false, 
      defaultValue: true, 
      table: { 
        header: 'Status', 
        width: '100px', 
        sortable: true, 
        cellRenderer: 'boolean' 
      }, 
      filterable: true, 
      validation: { 
        required: false 
      }, 
      switchLabel: 'Forward to option is active' 
    },
    { 
      name: 'record_order', 
      label: 'Display Order', 
      type: 'number', 
      required: false, 
      table: { 
        header: 'Order', 
        width: '80px', 
        sortable: true 
      }, 
      validation: { 
        required: false, 
        min: 1, 
        max: 999, 
        integer: true 
      }, 
      step: 1, 
      decimals: 0, 
      allowNegative: false 
    },
    { 
      name: 'color', 
      label: 'Display Color', 
      type: 'color', 
      required: false, 
      table: { 
        header: 'Color', 
        width: '100px', 
        sortable: false, 
        cellRenderer: 'color' 
      }, 
      validation: { 
        required: false 
      } 
    }
  ],
  get tableColumns() { 
    return this.fields
      .filter(field => field.table !== false && !field.hidden)
      .map(field => ({
        key: field.name,
        header: field.table?.header || field.label,
        width: field.table?.width || 'auto',
        sortable: field.table?.sortable !== false,
        displayField: field.table?.displayField || field.name,
        cellRenderer: field.table?.cellRenderer || 'default'
      })); 
  },
  filterableFields: ['name', 'description', 'isActive'],
  filterGroups: [
    { 
      name: 'basic', 
      label: 'Basic Filters', 
      fields: ['name', 'isActive'] 
    }, 
    { 
      name: 'advanced', 
      label: 'Advanced Filters', 
      fields: ['description'] 
    }
  ],
  customSortOrders: { 
    isActive: [true, false], 
    record_order: 'asc' 
  },
  messages: { 
    loading: 'Loading forward to options...', 
    noData: 'No forward to options found.', 
    saveSuccess: 'Forward to option saved successfully!', 
    deleteConfirm: 'Are you sure you want to delete this forward to option?' 
  },
  layout: { 
    mode: 'sections', 
    sections: [
      { 
        id: 'basic', 
        title: 'Forward To Information', 
        icon: '📤', 
        columns: 2, 
        fields: [
          { name: 'name' }, 
          { name: 'isActive' }, 
          { name: 'record_order' }, 
          { name: 'color' }
        ] 
      }, 
      { 
        id: 'details', 
        title: 'Additional Details', 
        icon: '📝', 
        columns: 1, 
        fields: [
          { name: 'description' }
        ] 
      }
    ] 
  },
  trackingSection: createTrackingConfig('ComplaintForwardTo'),
  labels: { 
    singular: 'Forward To', 
    plural: 'Forward To Options', 
    addButton: 'Add Forward To Option', 
    pageTitle: 'Forward To Management' 
  },
  fieldsToRemove: ['id', 'createdAt', 'updatedAt', 'createdById', 'updatedById', 'complaints'],
  exportFileName: 'complaint-forward-to',
  transformData: (data) => { 
    const transformed = { ...data }; 
    if (transformed.record_order !== undefined) { 
      if (transformed.record_order === '' || transformed.record_order === null) { 
        delete transformed.record_order; 
      } else { 
        const numValue = parseInt(transformed.record_order, 10); 
        if (!isNaN(numValue)) { 
          transformed.record_order = numValue; 
        } else { 
          delete transformed.record_order; 
        } 
      } 
    } 
    return transformed; 
  },
  validateField: null
};

